import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "ci_cookie_consent";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(KEY);
    if (!consent) {
      const t = setTimeout(() => setShow(true), 2600);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    localStorage.setItem(KEY + "_at", new Date().toISOString());
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-0 left-0 right-0 z-[90] p-4 md:p-6"
        >
          <div className="max-w-5xl mx-auto bg-navy text-paper border border-gold/30 shadow-2xl p-6 md:p-7 flex flex-col md:flex-row md:items-center gap-5">
            <div className="flex items-start gap-4 flex-1">
              <Cookie className="text-gold shrink-0 mt-1" size={22} />
              <p className="text-sm text-paper/75 leading-relaxed">
                Questo sito utilizza solo cookie tecnici necessari al suo funzionamento.
                Non usiamo cookie di profilazione. Consulta la{" "}
                <Link to="/cookie" data-testid="cookie-banner-cookie-link" className="text-gold underline underline-offset-2 hover:text-gold-soft">Cookie Policy</Link>{" "}
                e la{" "}
                <Link to="/privacy" data-testid="cookie-banner-privacy-link" className="text-gold underline underline-offset-2 hover:text-gold-soft">Privacy Policy</Link>.
              </p>
            </div>
            <div className="flex items-center gap-3 shrink-0">
              <button
                data-testid="cookie-reject"
                onClick={() => decide("necessary")}
                className="px-5 py-3 text-[0.7rem] uppercase tracking-[0.18em] border border-paper/25 text-paper/80 hover:border-paper hover:text-paper transition-colors"
              >
                Solo necessari
              </button>
              <button
                data-testid="cookie-accept"
                onClick={() => decide("all")}
                className="px-6 py-3 text-[0.7rem] uppercase tracking-[0.18em] bg-gold text-navy hover:bg-gold-soft transition-colors"
              >
                Accetta
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
